export function getIsInternalLink(url: string, internalBaseUrl: string): boolean {
    try {
        const { origin } = new URL(url);
        return origin === internalBaseUrl;
    } catch (_) {
        return true;
    }
}
